/*
 * How long a live view waits before asking the server again. Pure, so the
 * rule is tested without timers (intervals.test.js).
 *
 * Live updates are polled, not pushed (docs/CHAT.md): the API is a Lambda that
 * cannot hold a connection open, and the desktop server cannot stream. So the
 * polling must stay cheap:
 *   - a hidden page asks nothing at all (null: wait for it to be shown);
 *   - each failure in a row doubles the wait, up to `max`;
 *   - every wait is spread by ±`jitter`, so many open tabs do not ask in step.
 */
export const DEFAULTS = { base: 4000, max: 60000, jitter: 0.2 };

export function nextDelay({ visible = true, failures = 0, base = DEFAULTS.base, max = DEFAULTS.max,
  jitter = DEFAULTS.jitter, random = Math.random } = {}) {
  if (!visible) return null;
  const wait = failures > 0 ? Math.min(base * 2 ** failures, max) : base;
  const spread = wait * jitter;
  return Math.max(0, Math.round(wait - spread + random() * 2 * spread));
}

/** Whether a page is shown right now (a missing `document` counts as shown). */
export function pageVisible(doc = (typeof document !== 'undefined' ? document : null)) {
  return !doc || doc.visibilityState !== 'hidden';
}
